import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialChipsInputComponent } from './materialChipsInput.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MaterialModule} from '../../material.module';

@NgModule({
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    MaterialModule

  ],
  declarations: [
    MaterialChipsInputComponent

  ],
  exports:[MaterialChipsInputComponent]
})
export class MaterialChipsInputModule {

}
